import PortalIdParser from 'PortalIdParser';
import quickFetch from 'quick-fetch';
import { getFullUrl } from 'hubspot-url-utils';
import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
// @ts-expect-error not yet converted
import { reportError } from 'ContentUtils/helpers/sentry';
import { createRpcClientV2 } from 'rpc-client-utils';
import { isAuthedAppPreview, shouldIgnorerPlayerErrorsForUserAgent } from 'video-embed/utils/env';
import { getPreviewPlayerRpc } from '../../__generated__/chirp/com/hubspot/video/rpc/HubSpotVideoRpc';
function consolidatedEntityToVideoObject(entity) {
  var _entity$mp4FileUrl, _entity$primaryPlayba, _entity$thumbnailUrl, _entity$thumbnailSour, _entity$posterUrl, _entity$width, _entity$height, _entity$duration, _entity$isEmbeddable, _entity$folderId, _entity$folderPath;
  return {
    portalId: entity.portalId,
    videoId: entity.videoId,
    crmObjectId: entity.crmObjectId,
    sourceFileId: entity.sourceFileId,
    fileUrl: entity.sourceFileUrl,
    mp4FileUrl: (_entity$mp4FileUrl = entity.mp4FileUrl) !== null && _entity$mp4FileUrl !== void 0 ? _entity$mp4FileUrl : null,
    primaryPlaybackId: (_entity$primaryPlayba = entity.primaryPlaybackId) !== null && _entity$primaryPlayba !== void 0 ? _entity$primaryPlayba : null,
    transcodingState: entity.transcodingState ? String(entity.transcodingState) : '',
    title: entity.title,
    createdAt: new Date(entity.createdAt).toISOString(),
    updatedAt: entity.updatedAt ? new Date(entity.updatedAt).toISOString() : null,
    deletedAt: entity.deletedAt ? new Date(entity.deletedAt).toISOString() : null,
    thumbnailUrl: (_entity$thumbnailUrl = entity.thumbnailUrl) !== null && _entity$thumbnailUrl !== void 0 ? _entity$thumbnailUrl : '',
    thumbnailSourceFileId: (_entity$thumbnailSour = entity.thumbnailSourceFileId) !== null && _entity$thumbnailSour !== void 0 ? _entity$thumbnailSour : null,
    thumbnailSourceFileUrl: null,
    posterUrl: (_entity$posterUrl = entity.posterUrl) !== null && _entity$posterUrl !== void 0 ? _entity$posterUrl : '',
    width: (_entity$width = entity.width) !== null && _entity$width !== void 0 ? _entity$width : 0,
    height: (_entity$height = entity.height) !== null && _entity$height !== void 0 ? _entity$height : 0,
    duration: (_entity$duration = entity.duration) !== null && _entity$duration !== void 0 ? _entity$duration : 0,
    isEmbeddable: (_entity$isEmbeddable = entity.isEmbeddable) !== null && _entity$isEmbeddable !== void 0 ? _entity$isEmbeddable : false,
    folderId: (_entity$folderId = entity.folderId) !== null && _entity$folderId !== void 0 ? _entity$folderId : null,
    folderPath: (_entity$folderPath = entity.folderPath) !== null && _entity$folderPath !== void 0 ? _entity$folderPath : null,
    altText: null,
    subtitleLanguageCodes: entity.subtitleLanguageCodes.map(String),
    chapters: entity.chapters ? {
      items: entity.chapters.items || []
    } : undefined,
    seoDescription: entity.description || null,
    videoOrigin: entity.videoOrigin != null ? String(entity.videoOrigin) : null,
    videoAttributes: entity.videoAttributes.map(String)
  };
}
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
function fetchPlayer(id, params = {}) {
  if (isAuthedAppPreview()) {
    var _params$parentDomain;
    return chirpClient.call(getPreviewPlayerRpc, {
      request: {
        videoId: id,
        parentDomain: (_params$parentDomain = params.parentDomain) !== null && _params$parentDomain !== void 0 ? _params$parentDomain : undefined
      },
      timeout: 90000
    }).then(player => {
      var _player$parentDomainI;
      return {
        video: consolidatedEntityToVideoObject(player.video),
        gates: player.gates,
        parentDomain: {
          isCms: (_player$parentDomainI = player.parentDomainIsCms) !== null && _player$parentDomainI !== void 0 ? _player$parentDomainI : false
        }
      };
    });
  }
  const query = Object.assign({
    portalId: PortalIdParser.get()
  }, params);
  return noAuthHttp.get(`video/v1/public/${id}/player`, {
    timeout: 90000,
    query,
    withCredentials: false
  });
}
export function fetchPublicPlayer(id, params = {}) {
  const earlyRequest = quickFetch.getRequestStateByName('videoPlayer');
  if (earlyRequest) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(resp => {
        // we can safely assume the domain is hosted on the CMS via request over customer domain working
        if (!resp.domainInfo) {
          resp.domainInfo = {
            isCms: true
          };
        }
        window._usedQuickFetch = true;
        quickFetch.removeEarlyRequest('videoPlayer');
        resolve(resp);
      });
      earlyRequest.onError(err => {
        console.warn('Early video player fetch failed:', err);
        if (!shouldIgnorerPlayerErrorsForUserAgent()) {
          reportError(err, {
            errorId: 'QUICK_FETCH_VIDEO_FAILED'
          });
        }
        fetchPlayer(id, params).then(resolve, reject).catch(reject);
      });
    });
  }
  return fetchPlayer(id, params);
}
export function trackPlayEvent(crmObjectId, sessionId, contactUtk, extra = {}) {
  const query = {
    portalId: PortalIdParser.get()
  };
  const data = Object.assign({}, extra, {
    crmObjectId,
    sessionId,
    contactUtk
  });
  return noAuthHttp.post('media-bridge/public/v1/media/played', {
    data,
    query,
    withCredentials: false
  });
}
export function trackSecondsViewed(crmObjectId, sessionId, contactUtk, extra = {}) {
  const query = {
    portalId: PortalIdParser.get()
  };
  if (extra.endState) {
    query.endState = true;
  }
  delete extra.endState;
  const data = Object.assign({}, extra, {
    crmObjectId,
    sessionId,
    contactUtk
  });
  return noAuthHttp.post('media-bridge/public/v1/media/seconds-viewed', {
    data,
    query,
    withCredentials: false
  });
}
export function trackCompletedPlay(crmObjectId, sessionId, contactUtk, extra = {}) {
  if (!navigator || typeof navigator.sendBeacon !== 'function') {
    return false;
  }
  try {
    const data = new Blob([JSON.stringify(Object.assign({
      crmObjectId,
      sessionId,
      contactUtk
    }, extra))], {
      type: 'text/plain'
    });
    // eslint-disable-next-line compat/compat
    return navigator.sendBeacon(`${getFullUrl('api')}/media-bridge/public/v1/media/completed-play?portalId=${PortalIdParser.get()}`, data);
  } catch (err) {
    console.error('Error tracking final attention span', err);
    return false;
  }
}